import React from "react";
import { BsChevronDown } from "react-icons/bs";
import styles from "./dropdown.module.css";

const DropdownToggle = ({
  selectedOption,
  label,
  styling,
  disabled,
  labelstyle,
  handleToggleDropdown,
  isOpen,
  errorMessage,
}) => {
  const dropdownClass = `
  ${
    !selectedOption &&
    !labelstyle &&
    styling !== "homepage" &&
    styling !== "quotepage"
      ? styles.notselectedFont
      : ""
  }
  ${styles.dropdownBase}
  ${
    styling === "homepage" || styling === "quotepage"
      ? styles.customSelectHomePage
      : styling === "transactionPage"
      ? styles.customSelectTransactionPage
      : styles.customSelect
  }
  ${disabled ? styles.disabledSelect : ""}
  ${errorMessage ? styles.errorBorder : ""}
`;

  return (
    <div className={dropdownClass} onClick={handleToggleDropdown}>
      {styling === "homepage" ||
      styling === "quotepage" ||
      styling === "transactionPage" ? (
        <>
          <img src={selectedOption?.image} alt="" className={styles.imagediv} />
          <div className={styles.currency}>{selectedOption?.value}</div>
        </>
      ) : (
        <>{selectedOption?.label || label}</>
      )}
      <span
        className={`${styles.dropdownArrow} ${
          isOpen ? styles.open : styles.close
        }`}
      >
        <BsChevronDown
          size={
            styling === "homepage" || styling === "quotepage"
              ? 16
              : styling === "transactionPage"
              ? 18
              : 12
          }
          style={
            styling !== "homepage" && styling !== "quotepage"
              ? { margin: "0px 10px" }
              : {}
          }
          className={styles.Arrowsymbol}
        />
      </span>
    </div>
  );
};

export default DropdownToggle;
